// import { GraphicBarComponent } from "components/graphic/custom/bar.graphic.component"
import { useGetSantanderRoomDashboardDataApi } from "api/dashboard.api"
import { Filters } from "components/filters/filters.component"
import { GraphicBarComponent } from "components/graphic/santander/bar.graphic.component"
import { Page } from "components/page/page.component"
import { RoomReservationCard } from "components/roomReservationCard/roomReservationCard.component"
import { View } from "components/view/view.component"
import { Text } from "components/text/text.component"
import { FilterType } from "model/filter.model"
import { useEffect, useState } from "react"
import { getSantanderRoomColor } from "utils/color.util"
import { Skeleton } from "components/skeleton"
import style from './dashboard.room.santander.module.css'

export const DashboardRoomSantanderPage = ({companyId, salaId}: {companyId: string, salaId: string}) => {
    const [selectedRoomId, setSelectedRoomId] = useState<string | undefined>(salaId);
    const {data, get, loading} = useGetSantanderRoomDashboardDataApi()

    function handleFilterChange(filter: FilterType){
        setSelectedRoomId(filter.rooms?.at(0)?.id);
    }

    function getData() {
        if(!selectedRoomId) {
            get({roomId: ''}) // clear data
            return
        }
        get({
            roomId: selectedRoomId
        })
    }

    useEffect(()=>{
        getData()
        const interval = setInterval(getData, 60000)
        return () => clearInterval(interval)
    // eslint-disable-next-line
    }, [selectedRoomId, companyId])

    const roomData = data?.roomData;
    const capacity = data?.roomData?.capacity;

    return <Page className="" menu header title="Dashboard Sala">
        <View className={style.PageContent}>
            {!salaId && <Filters
                showBuildings
                showAreas
                showRooms
                onlyEnableBuildings
                onlyEnableAreas
                onlyEnableRooms
                onlyOneRoom
                roomIndicatorIds={['reserva-sala', 'room-occupation-status']}
                companyId={companyId}
                onChange={handleFilterChange}
                initialRoomId={salaId}
            />}
            {loading && <div className={style.skeletonContainer}><Skeleton className={style.graphicSkeleton} color='bg3'/> <Skeleton className={style.cardSkeleton} color='bg3'/></div>}
            {(data && !loading) && <View className={style.DataContainer}>
                {(data.roomData.buildingName || data.roomData.areaName || data.roomData.name) && <View className={style.Title}><Text>{data.roomData.buildingName} {data.roomData.areaName ? `- ${data.roomData.areaName}` : ''} {data.roomData.name ? `- ${data.roomData.name}` : ''}</Text></View>}
                <View style={{ width: '100%', height: '100%',backgroundColor: 'var(--bg2)', borderRadius: '20px' }}>
                    <View style={{ margin: '20px 30px'}}>
                        <GraphicBarComponent 
                            data={ data?.allDayData?.map(d => ({
                                date: new Date(d.date),
                                value: (d.occupied === undefined) ? 0 : 1,
                                color: getSantanderRoomColor(false, d.occupied, undefined),
                                tooltipLabel: d.occupied === undefined ? `${(new Date(d.date)).toLocaleString('pt-BR', { hour: '2-digit', minute: '2-digit' })} - sem dados` 
                                    : `${(new Date(d.date)).toLocaleString('pt-BR', { hour: '2-digit', minute: '2-digit' })} - ${d.occupied ? 'ocupada' : 'desocupada'}`
                                })) || []
                            } 
                        />
                    </View>
                </View>
                {roomData && <RoomReservationCard
                    color={getSantanderRoomColor(false, roomData?.occupied, undefined)}
                    title={roomData.name}
                    occupied={roomData.occupied}
                    capacity={capacity ? Number(capacity) : undefined}
                    // reserved={roomData?.reserved}
                    // reservedBy={roomData?.reservedBy}
                    // reserveStartAt={roomData?.reserveStartAt}
                    // reserveEndAt={roomData?.reserveEndAt}
                    id={roomData.id}
                    sn={undefined}
                />}
            </View>}
        </View>
    </Page>
}